<ng-template #content let-modal>
  <div class="modal-header" style="  background: linear-gradient(to bottom, #F9F9FC 0%, #EEEEF4 100%);    height: 50px;
  width: 720;">
    <h4 class="modal-title" id="modal-basic-title" style="font-size: 16px;
      font-weight: 500;">
      Dictionary
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()"> <span aria-hidden="true"
      style="color: black !important;">
        &times;
      </span> </button>
  </div>
  <div class="modal-body">
    <div class="d-flex mt-2">
      <p class="me-3"> Turn Dictionary on/off against this Document. </p>
      <div class="d-flex mrg-left" >
        <label for="chbActive" class="turn mb-0">{{ "Turn Dictionary" }}</label>
        <div class="form-check form-switch-md mb-0 ">
          <div class="on-off-toggle">
            <input class="on-off-toggle__input" type="checkbox" id="bopis" [checked]="isDictionaryEnabled"          (click)="onToggleClick($event)" />
            <label for="bopis" class="on-off-toggle__slider"></label>
          </div>
        </div>
      </div>
    </div>
    <form>
      <div class="d-flex">
        <div class="input-group my-2 p-1 rounded modal-bd-light">

            <input class="form-control border-0 me-2" type="text" ngDefaultControl name="dictWord" id="dictWord"
              value="{{ dictWord }}" [(ngModel)]="dictWord" onfocus="this.placeholder=''"
              onblur="this.placeholder='Add a new word'" placeholder="Add a new word" aria-label="short_link" style="
                height: unset;
                background-color: white !important ;
                color: #787878;
              " />

        </div>
        <div class="float-right mt-2 ms-3">
          <button type="button " class="btn btn-modal-dark add float-right" (click)="updateUserDictionary()"
            style="width: 77px; border-radius: 4px"> Add </button>
        </div>
      </div>
      <div>
        <p class="mt-2" style="font-size: 16px; font-weight: 500;"> These words will no longer be flagged as
          misspellings. </p>
      </div>
      <div class="float-left word" style="background-color: #f9f9fc"> <span style="font-size: 16px; font-weight: 500;"
          class="upload-title pt-2 pb-1 float-left d-inline-block ms-1 ms-2">List of already added words</span>
        <div class="input-group df-alcenter modal-bd-light float-right col-lg-4 search"> <i
            class="fas fa-search pr-2"></i>
          <input style="margin-top: 3px" class="form-control border-0 bg-transparent custom-input" type="text"
            [(ngModel)]="searchTerm" [ngModelOptions]="{ standalone: true }" onfocus="this.placeholder=''"
            onblur="this.placeholder='Search'" placeholder="Search..." aria-label="short_link"    />
        </div>
      </div>
      <div class="row" id="dictonaryinnerbody" style="
          overflow: auto;
          margin-left: 1px;
          margin-right: 0px;
          justify-content: center;
        ">
        <table class="table list-unstyled list_words" style="
            border-spacing: 0 10px;
            border-collapse: separate;
          ">

          <tbody >
            <img src="../../assets/images/icons/nowordyet.svg" alt="nowordyet"
              *ngIf="!all_records?.length" style="margin-top: 7%; margin-left: 42%" />
            <p *ngIf="!all_records?.length" class="text-center" style="
                font-size: 16px;
                margin-top: 6px;
                margin-left: -3%;
              "> No word yet </p>
            <p style="
                text-align: center;
                margin-top: 10px;
                margin-top: 40px;
              " *ngIf="
                all_records?.length &&
                (dictListing | filter : searchTerm)
                  .length == 0
              ">
              <img src="../../assets/images/No error found illustration/no word (1).svg" alt="no-word" /> </p>
            <tr *ngFor="let row of dictListing | filter : searchTerm" style=" border-top-left-radius: 5px; background-color: #f9f9fc;    height: 27px;">
              <td style="border-top-left-radius: 5px;border-bottom-left-radius: 5px;border-left: 1px solid #dee2e6;background-color: #f9f9fc;     height: 27px;  " class="col-lg-12 added_word">
                {{ row.word.length > 20 ? (row.word | slice:0:20) + '...' : row.word }} </td>
              <td class="col-lg-12 remove_word" style="
              background-color: #f9f9fc;
                  height: 27px;
                  border: none;
                  border-top: 1px solid #dee2e6;
                  border-bottom: 1px solid #dee2e6;
                  margin-top: 0px;

                  border-top-right-radius: 5px
                  ;border-bottom-right-radius: 5px;
                  border-right: 1px solid #dee2e6;
                " id="fileListMsg3_{{ row.doc_id }}" (click)="deleteDictWord(row.dic_id)">

                  <app-icons-free-tools name="dictionaryCancelIcon" />
                 </td>
            </tr>

          </tbody>
        </table>
      </div>
      <p class="upload-title  float-left d-inline-block" style="color: green; margin-top: 7px"
      id="dictLoaderonoffmsg"></p> <p class="upload-title  float-left d-inline-block"
      style="color: green; margin-top: 7px" id="savefiletext3"></p> <p
      class=" upload-title  float-left d-inline-block" style="color: red; margin-top: 7px"
      id="dictLoader"></p>
      <p class="upload-title  float-left d-inline-block"
      style="color: green; margin-top: 7px" id="savefiletext2"></p>

    </form>
  </div>
</ng-template>
<button class="btn btn-lg btn-outline-primary d-none" (click)="openModels(content)"> Dictionary </button>


